import React from 'react'
import {
  UserLineThin,
  Wallet,
  PlusCircle,
  Lock,
  SmallArrowDown,
  QuestionCircle,
  Info,
} from '@/assets/icons'

export interface FaqAction {
  id: number
  titleKey: string
  descriptionKey: string
  icon: React.ComponentType<{ size?: number; color?: string }>
  link: string
  iconColor?: string
  iconBgColor?: string
}

const faqs: Omit<FaqAction, 'id'>[] = [
  {
    titleKey: 'screens:faqs.items.accountSettings.title',
    descriptionKey: 'screens:faqs.items.accountSettings.description',
    icon: UserLineThin,
    link: 'https://kemapp.io/frequently-asked-questions/account-settings',
    iconColor: '#FFFFFF',
    // iconBgColor: '#6366F1',
  },
  {
    titleKey: 'screens:faqs.items.payments.title',
    descriptionKey: 'screens:faqs.items.payments.description',
    icon: Wallet,
    link: 'https://kemapp.io/frequently-asked-questions/payments',
    iconColor: '#FFFFFF',
    // iconBgColor: '#10B981',
  },
  {
    titleKey: 'screens:faqs.items.addingMoney.title',
    descriptionKey: 'screens:faqs.items.addingMoney.description',
    icon: PlusCircle,
    link: 'https://kemapp.io/frequently-asked-questions/adding-money',
    iconColor: '#FFFFFF',
    // iconBgColor: '#059669',
  },
  {
    titleKey: 'screens:faqs.items.securityPrivacy.title',
    descriptionKey: 'screens:faqs.items.securityPrivacy.description',
    icon: Lock,
    link: 'https://kemapp.io/frequently-asked-questions/security-privacy',
    iconColor: '#FFFFFF',
    // iconBgColor: '#DC2626',
  },
  {
    titleKey: 'screens:faqs.items.withdrawingMoney.title',
    descriptionKey: 'screens:faqs.items.withdrawingMoney.description',
    icon: SmallArrowDown,
    link: 'https://kemapp.io/frequently-asked-questions/withdrawing-money',
    iconColor: '#FFFFFF',
    // iconBgColor: '#F59E0B',
  },
  {
    titleKey: 'screens:faqs.items.support.title',
    descriptionKey: 'screens:faqs.items.support.description',
    icon: QuestionCircle,
    link: 'https://kemapp.io/frequently-asked-questions/support',
    iconColor: '#FFFFFF',
    // iconBgColor: '#8B5CF6',
  },
  {
    titleKey: 'screens:faqs.items.other.title',
    descriptionKey: 'screens:faqs.items.other.description',
    icon: Info,
    link: 'https://kemapp.io/frequently-asked-questions',
    iconColor: '#FFFFFF',
    // iconBgColor: '#6B7280',
  },
]

export const faqActionsList = faqs.map((faq, index) => ({
  id: index,
  ...faq,
}))
